import { connect, clearFocusCurrentSessionItem, QuizSession } from '@instructure/quiz-core';
import { TakeBody as TakeBodyPresenter } from './presenter';
export function mapStateToProps(state, ownProps) {
  var quizSessionId = ownProps.quizSessionId;
  var quizSession = QuizSession.create(state.getIn(['quizSessions', quizSessionId]));
  var sessionItems = quizSession.getSessionItems();
  var isOneQuestionAtATime = quizSession.isOneQuestionAtATime();
  var focusCurrentSessionItem = state.getIn(['taking', 'focusCurrentSessionItem']);
  var sessionItemsCount = quizSession.get('sessionItemsCount') || 0;
  var allowBacktracking = quizSession.allowBacktracking;
  var showProgress = !allowBacktracking;
  var isBuildOnLastAttempt = quizSession.get('buildOnLastAttempt');
  var useBolaPosition = isBuildOnLastAttempt && allowBacktracking;
  var bolaSessionItemsCount = quizSession.get('bolaSessionItemsCount');
  var focusTitleAndInstructions = state.getIn(['taking', 'focusTitleAndInstructions']);
  return {
    isOneQuestionAtATime: isOneQuestionAtATime,
    focusCurrentSessionItem: focusCurrentSessionItem,
    sessionItems: sessionItems,
    sessionItemsCount: sessionItemsCount,
    showProgress: showProgress,
    isBuildOnLastAttempt: isBuildOnLastAttempt,
    bolaSessionItemsCount: bolaSessionItemsCount,
    useBolaPosition: useBolaPosition,
    focusTitleAndInstructions: focusTitleAndInstructions
  };
}
var mapDispatchToProps = {
  clearFocusCurrentSessionItem: clearFocusCurrentSessionItem
};
export var TakeBody = connect(mapStateToProps, mapDispatchToProps)(TakeBodyPresenter);
export default TakeBody;